import { MouseEvent } from 'react';

import {
  Card,
  CardContent as CardBody,
  Box as Flex,
  Typography as Text,
} from '@material-ui/core';

import { AttachmentFragment } from '@spotify/confidence-graphql';

import { useArtifactDisplay } from '../../hooks/useArtifactDisplay';
import { ArtifactActionsMenu } from '../ArtifactActionsMenu';
import { ArtifactIcon } from '../ArtifactIcon';
import styles from './ArtifactCardBase.module.css';

const stopPropagation = (e: MouseEvent) => e.stopPropagation();

interface ArtifactCardBaseProps {
  artifact: AttachmentFragment;
  resolvedDisplayName?: string;
  onNavigate: () => void;
  onDelete?: () => void;
}

export const ArtifactCardBase = ({
  artifact,
  resolvedDisplayName,
  onNavigate,
  onDelete,
}: ArtifactCardBaseProps) => {
  const { Icon, typeLabel, displayName } = useArtifactDisplay(
    artifact,
    resolvedDisplayName,
  );

  return (
    <button type="button" className={styles.cardButton} onClick={onNavigate}>
      <Card className={styles.card}>
        <CardBody>
          <Flex
            display="flex"
            alignItems="center"
            style={{
              gap: 'var(--bui-space-2)',
            }}
          >
            <ArtifactIcon>
              <Icon size={16} />
            </ArtifactIcon>
            <Flex
              display="flex"
              className={styles.info}
              flexDirection="column"
              style={{
                gap: '0',
              }}
            >
              <Text
                variant="body1"
                color="textPrimary"
                noWrap
                style={{
                  fontWeight: 'bold',
                }}
              >
                {displayName}
              </Text>
              <Text variant="body2" color="textSecondary" noWrap>
                {typeLabel}
              </Text>
            </Flex>
            {onDelete && (
              <span
                role="toolbar"
                className={styles.menuButton}
                onClick={stopPropagation}
                onKeyDown={e => e.stopPropagation()}
              >
                <ArtifactActionsMenu
                  artifact={artifact}
                  resolvedDisplayName={resolvedDisplayName}
                  onDelete={onDelete}
                />
              </span>
            )}
          </Flex>
        </CardBody>
      </Card>
    </button>
  );
};
